export default function specificRateCardSelection(config) {
    if (!config.data) return null;

    let result = {};
    let tableData = [];

    let row = [{
        label: {
            id:  + "rate-card-specific|label",
            columnId: "rate-card-specific",
            rowSpan: 2,
            type: 'string',
            value: config.data.label,
            width: '15',
            displayAsIs: true,
            showInMobileViewAs: 'string'
        }
    }];

    const rowIds = [`${config.tableType}|head`, `${config.tableType}|body`];
    // rowIds.forEach((rowId) => {
    config.columns.forEach(column => {
        const columnId = column.id;
        const displayAsIs = true;
        const columnDataType = 'string';
        const highlightColumn = 'string';

        row.push({
            [columnId]: {
                id: columnId + "|" + rowIds[0],
                columnId: columnId,
                type: columnDataType,
                value: column.id.split('-')[1],
                width: column.width,
                displayAsIs: displayAsIs,
                showInMobileViewAs: column.showInMobileViewAs,
                highlightColumn: highlightColumn,
                disbled: config.disableCheckBoxes
            }
        });

    });

    tableData.push({
        id: rowIds[0],
        data: row
    });
    row =[];
    config.columns.forEach(column => {
        const columnId = column.id;
        const displayAsIs = column.data.displayInBodyAsIs;
        const columnDataType = column.data.displayInBodyAs;
        const highlightColumn = column.data.highlightBodyText;

        row.push({
            [columnId]: {
                id: columnId + "|" + rowIds[0],
                columnId: columnId,
                type: columnDataType,
                value: config.data.tableData[columnId.split('-')[1]],
                width: column.width,
                displayAsIs: displayAsIs,
                showInMobileViewAs: column.showInMobileViewAs,
                highlightColumn: highlightColumn,
                disbled: config.disableCheckBoxes,
                clickHandler: (columnDataType !== "string" && config.bodyButtonsHandler) ? event => config.bodyButtonsHandler(event, columnId) : null
            }
        });

    });
    tableData.push({
        id: rowIds[1],
        data: row
    });
    // });





    result['columns'] = config.columns;
    result['data'] = tableData;
    ;
    return result;
}